import { useTranslation } from '@web_opxp/features';

export default function NoDataPlaceholder() {
  const { t } = useTranslation();

  return (
    <div className="highscores-view no-data">
      <p>{t('Highscore.NoData')}</p>
    </div>
  );
}
